import profile from './profile';
import settings from './settings';

export default {
  chats: {
    title: 'Chats',
    search: {
      placeholder: 'Search messages or users',
    },
  },
  profile,
  settings,
}
